import { useCallback } from 'react';
import { agreementsApi } from '@/modules/agreements/services/api';
import { useAsyncResource } from '@/shared/hooks/use-async-resource';
import { isForbidden } from '@/modules/agreements/shared';

/** The subject's own execution, with its download link. */
export function useMyExecution(executionId: string) {
  const load = useCallback(() => agreementsApi.getMyExecution(executionId), [executionId]);
  const { data, error, isLoading } = useAsyncResource(load);
  return { execution: data, error, isLoading, isDenied: isForbidden(error) };
}
